import type { TReportTemplateContentSetup } from '@team-milva/lab-models/resources'
import { t } from '@/locales'

export interface IContentSetupOption {
  value: TReportTemplateContentSetup
  text: string
  description: string
}

/**
 * The choices shown for a lab report template's content setup — in the create modal and in the
 * editor's "Rapportindhold" card, so both read the same.
 */
export function getContentSetupOptions(): IContentSetupOption[] {
  return [
    {
      value: 'standard',
      text: t('W: Standard'),
      description: t(
        'W: Analyseresultater, derefter automatiske analysebeskrivelser og valgte beskrivelser samlet for hele rapporten.'
      ),
    },
    {
      value: 'samples-explained',
      text: t('W: Forklaringer pr. prøve'),
      description: t(
        'W: Hver prøves analyseresultater efterfulgt af forklaringer: analysernes automatiske beskrivelser og de beskrivelser, der hører til prøvens resultater.'
      ),
    },
  ]
}

/** The setup's short name — the list's second line under the type, and the option's title. */
export function getContentSetupLabel(contentSetup: TReportTemplateContentSetup): string {
  return (
    getContentSetupOptions().find((option) => option.value === contentSetup)?.text ??
    contentSetup
  )
}
